import $ from 'jquery';

// You can define any private functions here
var Vec2 = function (x, y) {
    return [x, y];
  },
  removeTail = function (a) {
    var b = a.slice(0, a.length - 1);
    return b;
  },
  pointInsideConvexPolygon = function (point, polyVerts) {
    for (var i = 0; i < polyVerts.length; i++) {
      if (polyVerts[i].includes(NaN)) return false;
      var v1 = Vec2.nsub(polyVerts[i], point),
        v2 = Vec2.nsub(polyVerts[i + 1 > polyVerts.length - 1 ? 0 : i + 1], point),
        edge = Vec2.nsub(v1, v2),
        x = Vec2.perpdot(edge, v1);
      // If the point lies directly on an edge then count it as in the polygon
      if (x > 0) return false;
    }
    return true;
  },
  // getFeedBackRange = function (f) {
  //     return [f[0][0][0], f[1][0][0]];
  // },

  // polyVerts : vertexes must be given clockwise order
  polygonInsidePolygon = function (polygon, polyVerts) {
    var p1 = removeTail(polygon),
      p2 = removeTail(polyVerts);
    for (var i = 0; i < p1.length; i++) {
      if (!pointInsideConvexPolygon(p1[i], p2)) {
        return false;
      }
    }
    return true;
  },
  validateVref = function (
    bottomMargin,
    topMargin,
    vsBottom,
    vsTop,
    vref,
    vrefLabel,
    vsPosLabel,
    vsNegLabel,
    intl,
    partNumber,
  ) {
    var result = false,
      message = { message: '', priority: 4 },
      minRange = vsBottom + bottomMargin,
      maxRange = vsTop - topMargin;

    result = vref >= minRange && vref <= maxRange ? true : false;

    message.message =
      result === false
        ? intl.t('schematicValidation.error_vref', {
            partNumber: partNumber,
            vsTop: vsTop,
            vsBottom: vsBottom,
            minRange: minRange,
            maxRange: maxRange,
            vrefLabel: vrefLabel,
            vsPosLabel: vsPosLabel,
            vsNegLabel: vsNegLabel,
          })
        : '';
    return [result, message];
  },
  validateGain = function (gain, bottomRange, topRange, gainType, gainValues, intl, partNumber) {
    var result = false,
      message = { message: '', priority: 3 };

    if (gainType.toLowerCase() != 'discrete') {
      result = gain >= bottomRange && gain <= topRange ? true : false;

      message.message =
        result === false
          ? intl.t('schematicValidation.error_gain', {
              partNumber: partNumber,
              bottomRange: bottomRange,
              topRange: topRange,
            })
          : '';
    } else {
      // This check is for finding recommended parts
      for (var g = 0; g < gainValues.length; g++) {
        result = gainValues[g].id == gain ? true : false;
        if (result) break;
      }
    }
    return [result, message];
  },
  validateSupplies = function (vsBottom, vsTop, minRange, maxRange, vsPosLabel, vsNegLabel, intl, partNumber) {
    var result = false,
      message = { message: '', priority: 2 },
      difference = vsTop - vsBottom;

    result = difference >= minRange && difference <= maxRange ? true : false;
    message.message =
      result === false
        ? intl.t('schematicValidation.error_voltage_supplies', {
            partNumber: partNumber,
            minRange: minRange,
            maxRange: maxRange,
            vsPosLabel: vsPosLabel,
            vsNegLabel: vsNegLabel,
          })
        : '';
    return [result, message];
  },
  validateVin = function (
    supplyNeg,
    supplyPos,
    inputNegMar,
    inputPosMar,
    upperMargin,
    vin,
    type,
    intl /*, partNumber*/,
  ) {
    var result = false,
      message = { message: '', priority: 5 },
      vIL = supplyNeg + inputNegMar,
      vIH = supplyPos - inputPosMar - upperMargin;

    if (vin <= vIH && vin >= vIL) {
      result = true;
    } else if (vin < vIL) {
      vIL = Math.round(vIL * 100) / 100;
      message.message = intl.t('internalValidation.error_vIL', { type: type, vIL: vIL });
      result = false;
    } else if (vin > vIH) {
      vIH = Math.round(vIH * 100) / 100;
      message.message = intl.t('internalValidation.error_vIH', { type: type, vIH: vIH });
      result = false;
    }
    return [result, message];
  },
  validateVdiffC = function (supplyNeg, supplyPos, vdir, gda, vdiff, type, intl /*, partNumber*/) {
    var result = false,
      message = { message: '', priority: 7 },
      vIL = -(vdir * (supplyPos - supplyNeg) + gda),
      vIH = +(vdir * (supplyPos - supplyNeg) + gda);

    if (vdiff <= vIH && vdiff >= vIL) {
      result = true;
    } else if (vdiff < vIL) {
      vIL = Math.round(vIL * 100) / 100;
      message.message = intl.t('internalValidation.error_vIL', { type: type, vIL: vIL });
      result = false;
    } else if (vdiff > vIH) {
      vIH = Math.round(vIH * 100) / 100;
      message.message = intl.t('internalValidation.error_vIH', { type: type, vIH: vIH });
      result = false;
    }
    return [result, message];
  },
  validateVoutInternal = function (
    supplyNeg,
    supplyPos,
    outputNegMar,
    outputPosMar,
    vout,
    voutLabel,
    intl /*, partNumber*/,
  ) {
    var result = false,
      message = { message: '', priority: 6 },
      vOL = supplyNeg + outputNegMar,
      vOH = supplyPos - outputPosMar;

    if (vout <= vOH && vout >= vOL) {
      result = true;
    } else if (vout < vOL) {
      vOL = Math.round(vOL * 100) / 100;
      message.message = intl.t('internalValidation.error_vOL', { vOL: vOL, voutLabel: voutLabel });
      result = false;
    } else if (vout > vOH) {
      vOH = Math.round(vOH * 100) / 100;
      message.message = intl.t('internalValidation.error_vOH', { vOH: vOH, voutLabel: voutLabel });
      result = false;
    }
    return [result, message];
  },
  validateVouts = function (
    supplyNeg,
    supplyPos,
    outputNegMar,
    outputPosMar,
    vouts,
    vref,
    vrefLabel,
    intl,
    partNumber,
  ) {
    var result = true,
      message = { message: '', priority: 5 },
      vOL = supplyNeg + outputNegMar,
      vOH = supplyPos - outputPosMar,
      lowerLimit = vOL,
      upperLimit = vOH;

    if (vref != null) {
      var diffSpan = vOH - vOL,
        vocmAdjust = Math.abs((vOH + vOL) / 2 - vref) * 2,
        vDiffOutLimit = diffSpan - vocmAdjust;

      upperLimit = Math.abs(vDiffOutLimit);
      lowerLimit = upperLimit * -1;
    }

    for (var i = 0; i < vouts.length; i++) {
      //result = ((vouts[i] <= (supplyPos - outputPosMar)) && (vouts[i] >= (supplyNeg + outputNegMar))) ? true : false;
      if (!(vouts[i] <= upperLimit && vouts[i] >= lowerLimit)) {
        result = false;
        message.message = intl.t('schematicValidation.error_vouts', { partNumber: partNumber, vrefLabel: vrefLabel });
      }
    }
    return [result, message];
  },
  validateSubtractIn = function (
    supplyNeg,
    supplyPos,
    subtractorNeg,
    subtractorPos,
    subtractIn,
    type,
    intl /*, partNumber*/,
  ) {
    var result = false,
      message = { message: '', priority: 9 },
      low = supplyNeg + subtractorNeg,
      high = supplyPos - subtractorPos;

    if (subtractIn <= high && subtractIn >= low) {
      result = true;
    } else if (subtractIn < low) {
      low = Math.round(low * 100) / 100;
      message.message = intl.t('internalValidation.error_subtractIn_low', { type: type, low: low });
      result = false;
    } else if (subtractIn > high) {
      high = Math.round(high * 100) / 100;
      message.message = intl.t('internalValidation.error_subtractIn_high', { type: type, high: high });
      result = false;
    }
    return [result, message];
  },
  validateVcms = function (supplyNeg, supplyPos, inputNegMar, inputPosMar, vcms, intl, partNumber) {
    var result = true,
      message = { message: '', priority: 6 };
    for (var i = 0; i < vcms.length; i++) {
      result = vcms[i] <= supplyPos - inputPosMar && vcms[i] >= supplyNeg + inputNegMar ? true : false;
      if (result === false) {
        message.message = intl.t('schematicValidation.error_vcms', { partNumber: partNumber });
      }
    }
    return [result, message];
  },
  validateChargePumpSupply = function (
    chargePumpSupplyMin,
    chargePumpSupplyMax,
    chargePumpSupply,
    vddcpLabel,
    intl,
    partNumber,
  ) {
    var result = true,
      message = { message: '', priority: 2 };

    if (chargePumpSupply < chargePumpSupplyMin || chargePumpSupply > chargePumpSupplyMax) {
      message.message = intl.t('schematicValidation.error_vddcp', {
        vddcpLabel: vddcpLabel,
        partNumber: partNumber,
        min: chargePumpSupplyMin,
        max: chargePumpSupplyMax,
      });
      result = false;
    }

    return [result, message];
  },
  // validateOutputSupplyRange = function (outputNegSupplies, outputPosSupplies, outputSupplyRangeMin, outputSupplyRangeMax, outVspLabel, outVsmLabel, intl, partNumber) {
  //     var message = { message: "", priority: 7 },
  //         supplyRange = outputPosSupplies - outputNegSupplies;

  //     var result = supplyRange >= outputSupplyRangeMin && supplyRange <= outputSupplyRangeMax;
  //     if(result === false) {
  //         message.message = intl.t('schematicValidation.error_output_supply_range', {
  //             partNumber: partNumber,
  //             minRange: outputSupplyRangeMin,
  //             maxRange: outputSupplyRangeMax,
  //             outVsmLabel: outVsmLabel,
  //             outVspLabel: outVspLabel
  //         });
  //     }

  //     return [result, message];
  // },

  validateOutputNegSupply = function (
    outputNegSupplies,
    inputNegSupplies,
    inputPosSupplies,
    outVsmLabel,
    inVsmLabel,
    inVspLabel,
    intl,
    partNumber,
  ) {
    var result = true,
      message = { message: '', priority: 4 };

    if (outputNegSupplies != 0) {
      result = false;
      message.message = intl.t('schematicValidation.error_avss_vs_dvss', {
        partNumber: partNumber,
        outVsmLabel: outVsmLabel,
      });
    } else if (outputNegSupplies > inputNegSupplies + 30) {
      result = false;
      message.message = intl.t('schematicValidation.error_avss_vs_vssh', {
        outVsmLabel: outVsmLabel,
        inVsmLabel: inVsmLabel,
      });
    } else if (outputNegSupplies < inputPosSupplies - 30) {
      result = false;
      message.message = intl.t('schematicValidation.error_avss_vs_vddh', {
        outVsmLabel: outVsmLabel,
        inVspLabel: inVspLabel,
      });
    }

    return [result, message];
  },
  validateOutputPosSupply = function (outputPosSupplies, inputPosSupplies, outPosLabel, inPosLabel, intl) {
    let result = true,
      message = { message: '', priority: 4 };

    if (outputPosSupplies > inputPosSupplies) {
      result = false;
      message.message = intl.t('schematicValidation.error_vposout_vs_vposin', {
        vPosOutLabel: outPosLabel,
        vPosInLabel: inPosLabel,
      });
    }

    return [result, message];
  },
  validateVrefSpan = function (vref1, vref2, vrefSpan, intl) {
    let result = true,
      message = { message: '', priority: 4 };

    if ((vrefSpan || vrefSpan === 0) && vref2 - vref1 > vrefSpan) {
      result = false;
      message.message = intl.t('schematicValidation.error_vref_pins', { vrefSpan: vrefSpan });
    }

    return [result, message];
  },
  validateVinGain = function (
    supplyNeg,
    supplyPos,
    preAmpOutputNegMar,
    preAmpOutputPosMar,
    vinGain,
    type,
    intl /*, partNumber*/,
  ) {
    var result = false,
      message = { message: '', priority: 7 },
      preAmpLow = supplyNeg + preAmpOutputNegMar,
      preAmpHigh = supplyPos - preAmpOutputPosMar;

    if (vinGain <= preAmpHigh && vinGain >= preAmpLow) {
      result = true;
    } else if (vinGain < preAmpLow) {
      preAmpLow = Math.round(preAmpLow * 100) / 100;
      message.message = intl.t('internalValidation.error_vinGainMin_low', { type: type, preAmpLow: preAmpLow });
      result = false;
    } else if (vinGain > preAmpHigh) {
      preAmpHigh = Math.round(preAmpHigh * 100) / 100;
      message.message = intl.t('internalValidation.error_vinGainMax_high', { type: type, preAmpHigh: preAmpHigh });
      result = false;
    }
    return [result, message];
  },
  validatePolygons = function (polygons, intl, partNumber) {
    var result = false,
      messages = [],
      //errorContent = '',
      useOnError = {
        message: intl.t('operatingRangeValidation.error_polygons', { partNumber: partNumber }),
        priority: 8,
      },
      useOnInputLimitError = {
        message: intl.t('schematicValidation.error_vcms', { partNumber: partNumber }),
        priority: 7,
      };

    result = polygonInsidePolygon(polygons.inputSignal[0], polygons.preAmplifierInput[0])
      ? true
      : (messages.push(useOnInputLimitError), false);

    if (result === true) {
      if (!nullPolygon(polygons.preAmplifierOutput3Amp))
        result &= polygonInsidePolygon(polygons.inputSignal[0], polygons.preAmplifierOutput3Amp[0])
          ? true
          : (messages.push(useOnError), false);

      if (!nullPolygon(polygons.subtractorInputOutput))
        result &= polygonInsidePolygon(polygons.inputSignal[0], polygons.subtractorInputOutput[0])
          ? true
          : (messages.push(useOnError), false);

      if (!nullPolygon(polygons.outputAmplifier2Amp))
        result &= polygonInsidePolygon(polygons.inputSignal[0], polygons.outputAmplifier2Amp[0])
          ? true
          : (messages.push(useOnError), false);

      if (!nullPolygon(polygons.feedback1))
        result &= polygonInsidePolygon(polygons.inputSignal[0], polygons.feedback1[0])
          ? true
          : (messages.push(useOnError), false);

      if (!nullPolygon(polygons.feedback2)) {
        result &= polygonInsidePolygon(polygons.inputSignal[0], polygons.feedback2[0])
          ? true
          : (messages.push(useOnError), false);
        result &= polygonInsidePolygon(polygons.inputSignal[0], polygons.outputPinBoundry[0])
          ? true
          : (messages.push(useOnError), false);
      }
    }

    return [result, messages];
  },
  nullPolygon = function (poly) {
    return (poly.length === 1 && poly[0].length === 0) || poly.length === 0 ? true : false;
  };

Vec2.nsub = function (v1, v2) {
  return Vec2(v1[0] - v2[0], v1[1] - v2[1]);
};

// scalar cross product
Vec2.perpdot = function (v1, v2) {
  return v1[0] * v2[1] - v1[1] * v2[0];
};

$.fn.exists = function () {
  return this.length !== 0;
};

export default {
  validate: function (o, polygons, intl, partNumber) {
    var result = false,
      isGain = true,
      isVS = true,
      isVref = true,
      errorContent = '',
      inside = true,
      fields = [],
      messages = [],
      errorCount = 0;

    for (var i = 0; i < o.length; i++) {
      var field = o[i].fieldId,
        validationType = o[i].validationType,
        args = o[i].args,
        validationResults = null;

      switch (validationType) {
        case 1: {
          // Validates supply stays within margins.
          validationResults = validateSupplies(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            args[4],
            args[5],
            intl,
            partNumber,
          );
          isVS = validationResults[0] ? true : false;
          if (!isVS) errorCount++;
          break;
        }
        case 2: {
          // Validates vref falls within margins.
          validationResults = validateVref(
            Number(args[4]),
            Number(args[3]),
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            args[5],
            args[6],
            args[7],
            intl,
            partNumber,
          );
          isVref = validationResults[0] ? true : false;
          if (!isVref) errorCount++;
          break;
        }
        case 3: {
          // Validates gain falls within allotted range.
          validationResults = validateGain(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            args[3],
            args[4],
            intl,
            partNumber,
          );
          isGain = validationResults[0] ? true : false;
          if (!isGain) errorCount++;
          break;
        }
        case 4: {
          // Validates all points of vout falls within allotted range.
          validationResults = validateVouts(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            args[4],
            args[5] != null ? Number(args[5]) : null,
            args[6],
            intl,
            partNumber,
          );
          break;
        }
        case 5: {
          // Validates all points of Vcm falls within allotted range.
          validationResults = validateVcms(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            args[4],
            intl,
            partNumber,
          );
          break;
        }
        case 6: {
          // Validates that the output supply range falls within the allotted range.
          validationResults = validateSupplies(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            args[4],
            args[5],
            intl,
            partNumber,
          );
          let isValid = validationResults[0] ? true : false;
          if (!isValid) errorCount++;
          isVS = isVS || isValid;
          break;
        }
        case 7: {
          // Validates that the output neg supply compares correctly against other properties.
          validationResults = validateOutputNegSupply(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            args[3],
            args[4],
            args[5],
            intl,
            partNumber,
          );
          let isValid = validationResults[0] ? true : false;
          if (!isValid) errorCount++;
          isVS = isVS || isValid;
          break;
        }
        case 8: {
          // Validates that the output pos supply compares correctly against other properties.
          validationResults = validateOutputPosSupply(Number(args[0]), Number(args[1]), args[2], args[3], intl);
          let isValid = validationResults[0] ? true : false;
          if (!isValid) errorCount++;
          isVS = isVS || isValid;
          break;
        }
        case 9: {
          validationResults = validateVrefSpan(Number(args[0]), Number(args[1]), args[2], intl);
          let isValid = validationResults[0] ? true : false;
          if (!isValid) errorCount++;
          isVS = isVS || isValid;
          break;
        }
        case 10: {
          validationResults = validateChargePumpSupply(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            args[3],
            intl,
            partNumber,
          );
          let isValid = validationResults[0] ? true : false;
          if (!isValid) errorCount++;
          isVS = isVS || isValid;
          break;
        }
      }
      if (!validationResults[0]) {
        for (let j = 0; j < field.length; j++) {
          fields.push(field[j]);
        }
      }
      if (validationResults[1].message.length > 0) {
        messages.push(validationResults[1]);
      }
    }

    let validatedPolygonsResults = validatePolygons(polygons, intl, partNumber);
    inside = validatedPolygonsResults[0];
    messages = messages.concat(validatedPolygonsResults[1]);

    var highest, current, highestError;
    for (var r = 0; r < messages.length; r++) {
      current = messages[r].priority;
      if (r === 0) {
        highest = current;
        highestError = messages[r].message;
      }
      if (current < highest) {
        highest = current;
        highestError = messages[r].message;
      }
    }
    errorContent = typeof highestError !== 'undefined' ? highestError : '';

    result = errorCount === 0 ? true : false;
    return [result, inside, isGain, isVref, isVS, fields, errorContent];
  },

  validateInternalCircuitry: function (o, intl) {
    var fields = [],
      messages = [],
      errorCount = 0;
    for (var i = 0; i < o.length; i++) {
      var field = o[i].fieldId,
        validationType = o[i].validationType,
        args = o[i].args,
        validationResults = null;
      switch (validationType) {
        case 4: {
          // Validates vinPos and Neg falls within allotted range.
          validationResults = validateVin(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            Number(args[4]),
            Number(args[5]),
            args[6],
            intl,
          );
          break;
        }
        case 5: {
          // Validates vout falls within allotted range.
          validationResults = validateVoutInternal(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            Number(args[4]),
            args[5],
            intl,
          );
          break;
        }
        case 6: {
          // Validates vinPosGain and NegGain falls within allotted range.
          validationResults = validateVinGain(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            Number(args[4]),
            args[5],
            intl,
          );
          break;
        }
        case 7: {
          // Validates vdiff within allotted range.
          validationResults = validateVdiffC(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            Number(args[4]),
            args[5],
            intl,
          );
          break;
        }
        case 8: {
          // Validates subtractIn within allotted range.
          validationResults = validateSubtractIn(
            Number(args[0]),
            Number(args[1]),
            Number(args[2]),
            Number(args[3]),
            Number(args[4]),
            args[5],
            intl,
          );
          break;
        }
      }
      if (!validationResults[0]) {
        for (let j = 0; j < field.length; j++) {
          fields.push(field[j]);
        }
        errorCount++;
      }
      if (validationResults[1].message.length > 0) {
        messages.push(validationResults[1]);
      }
    }
    return { isValid: errorCount === 0, fields: fields, messages: messages };
  },
};
